export const UPDATE_MENU_KEY = 'UPDATE_MENU_KEY';
export const UPDATE_API_STATUS = 'UPDATE_API_STATUS';
export const CURRENT_SCREEN_TITLE = 'CURRENT_SCREEN_TITLE';
export const SEARCH_BOTS = 'SEARCH_BOTS';
export const GET_CRM_SCHEMA = 'GET_CRM_SCHEMA';
export const SAVE_CRM_SCHEMA = 'SAVE_CRM_SCHEMA';
export const UPDATE_CRM_SCHEMA = 'UPDATE_CRM_SCHEMA';
export const RESET_COMMON = 'RESET_COMMON';
export const SAVE_SELECTED_BOT = 'SAVE_SELECTED_BOT';
export const SAVE_ONLINE_STATUS = 'SAVE_ONLINE_STATUS';
export const SET_BOT_MODE = 'SET_BOT_MODE';
